// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    /* Style the .contact-content div */
.contact-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
}
.contact-content::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7);
}
    
        /* Style the content inside .contact-content */
.contact-content .row {
            color: #fff;
}

        /* Style the content divs inside .contact-content */
.contact-content .col-1 {
            /* Add your styling for the icon column */
}
.contact-content .col-11 {
            /* Add your styling for the address column */
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
